/* eslint import/prefer-default-export: "off" */
import generateDetailsLink from '@src/utils/generate.details.link'
import { ColumnType, ColumnProps } from '@src/components/data.grid'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type { History } from 'history'
import type { SearchResult } from '@src/redux/reducers/autocomplete.query'

const isPrivilegeByType = type => type === ResourceTypeEnum.PRIV_ACTION

export const getDatailColumns = (
  history: History,
  showScopeColumns: boolean
): ColumnProps<SearchResult>[] => [
  { type: ColumnType.selector },
  {
    field: 'identity_type',
    type: ColumnType.iconGraph
  },
  {
    field: 'identity',
    title: 'Identities',
    clickable: item =>
      item.identity &&
      item.identity_type &&
      !isPrivilegeByType(item.identity_type) &&
      item.identityAccountID,
    onClick: item => {
      const url = generateDetailsLink(item.identity_uri)
      history.push(url)
    }
  },
  {
    hide: !showScopeColumns,
    field: 'identity_uri',
    title: 'URI'
  },
  {
    field: 'resource_type',
    type: ColumnType.iconGraph
  },
  {
    field: 'resource',
    title: 'Resource',
    clickable: item =>
      item.resource_uri &&
      item.resource_type &&
      !isPrivilegeByType(item.resource_type) &&
      item.resourceAccountID,
    onClick: item => {
      const url = generateDetailsLink(item.resource_uri || item.resource)
      history.push(url)
    }
  },
  {
    field: 'identity_account_name',
    title: 'User Source'
  },
  {
    field: 'resource_account_name',
    title: 'Resource Source'
  },
  { field: 'actions_str', title: 'Actions' }
]
